const wishlistLabels = {
  'Add to wishlist': 'Dodaj do ulubionych',
  'Added to wishlist': 'Dodano do ulubionych',
  'Remove from wishlist': 'Usuń z ulubionych',
  'XB Wishlist Header Auto': 'Lista ulubionych',
};

function localizeWishlist(root = document) {
  root.querySelectorAll?.('.xb-wishlist-header-auto').forEach((button) => {
    button.setAttribute('aria-label', 'Lista ulubionych');
    button.setAttribute('title', 'Lista ulubionych');
  });

  root.querySelectorAll?.('.xb-wishlist-button button').forEach((button) => {
    const ariaLabel = button.getAttribute('aria-label');
    if (wishlistLabels[ariaLabel]) button.setAttribute('aria-label', wishlistLabels[ariaLabel]);

    const text = button.querySelector('.xb-wishlist-button__text');
    const currentText = text?.textContent?.trim();
    if (text && wishlistLabels[currentText]) text.textContent = wishlistLabels[currentText];
  });
}

localizeWishlist();

const wishlistObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes' && mutation.target.matches?.('.xb-wishlist-button button')) {
      const label = mutation.target.getAttribute('aria-label');
      if (wishlistLabels[label]) {
        const localizedLabel = wishlistLabels[label];
        mutation.target.setAttribute('aria-label', localizedLabel);

        const text = mutation.target.querySelector('.xb-wishlist-button__text');
        if (text) text.textContent = localizedLabel;
      }
    }

    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) localizeWishlist(node);
    });
  }
});

wishlistObserver.observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['aria-label'],
});

